import request from '@/utils/request'

export function getDeliveryOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/deliveryOrder.listDeliveryOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '获取送货订单列表失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function adminCloseDeliveryOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/deliveryOrder.adminCloseDeliveryOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '关闭送货订单失败'))
    }).catch(error => {
      reject(error)
    })
  })
}
